import React, { memo } from 'react';

import { Block } from '../../components/core';
import { FactorContributionContent } from './factor-contribution-content';
import { FactorContributionHeader } from './factor-contribution-header';

import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';

interface FactorContributionBlockProps {
  id: string;
}

export const FactorContributionBlock = memo(function InternalFactorContributionBlock({
  id,
}: FactorContributionBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <FactorContributionHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper]}>
        <FactorContributionContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
